import React from "react"
import { getThemeStylesheet } from "../utils/filters/build"
import EmbedCodeButton from "../components/EmbedCodeButton"

const RootLayout = ({ children, themeName, isAdmin, isPublic, apiKey }) => {
  const theme = getThemeStylesheet(themeName)

  return (
    <div data-theme={theme} className="mx-auto">
      {!isPublic && isAdmin && <EmbedCodeButton themeName={themeName} apiKey={apiKey} />}

      <div className="max-w-[1250px] mx-auto px-2">{children}</div>
    </div>
  )
}

export default RootLayout
